var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvoMenuDarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4054 13.7402H8.55521C8.54542 13.7402 8.53586 13.7431 8.52769 13.7485L5.45658 15.7733C5.42343 15.7952 5.37925 15.7715 5.37906 15.7318L5.36969 13.7782C5.36956 13.7507 5.34721 13.7284 5.31969 13.7284H3.86281C3.00021 13.7284 1.91942 12.8835 1.92751 11.7292C1.93351 10.8718 1.92725 7.72685 1.92725 6.10533C1.92725 5.47016 2.39039 4.0951 4.04469 4.0951C5.89158 4.0951 10.4209 4.09511 12.4066 4.09511C12.9747 4.09511 14.3159 4.67845 14.3159 6.0966C14.3159 7.51474 14.3159 9.72191 14.3159 10.1823",
    stroke: "white",
    strokeWidth: 0.89,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36865 7.53548H10.8726M5.36865 10.2875H8.77883",
    stroke: "white",
    strokeWidth: 1.15132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8476 10.5028C11.4982 10.5028 11.163 10.6269 10.9159 10.8478C10.6688 11.0687 10.5299 11.3683 10.5299 11.6806V14.8215C10.5299 15.1339 10.6688 15.4335 10.9159 15.6544C11.163 15.8753 11.4982 15.9994 11.8476 15.9994L13.6785 15.9994L15.8747 17.1772V15.9994H16.7531C17.1026 15.9994 17.4377 15.8753 17.6849 15.6544C17.932 15.4335 18.0708 15.1339 18.0708 14.8215V11.6806C18.0708 11.3682 17.932 11.0687 17.6849 10.8478C17.4377 10.6269 17.1026 10.5028 16.7531 10.5028L11.8476 10.5028Z",
    stroke: "white",
    strokeWidth: 0.802951,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 12.369H12.3612M15.875 14.1259H13.2396",
    stroke: "white",
    strokeWidth: 0.802951,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvoMenuDarkIcon);
export default __webpack_public_path__ + "static/media/convo-menu-dark-icon.c79c43f068e658d4755e2354bf1f78d2.svg";
export { ForwardRef as ReactComponent };